import React from 'react';
import CalculatedField from '../CalculatedField';
import { IoIosArrowRoundForward } from 'react-icons/io';
import FormUIOptions from '../../formElements/formUIOptions';
import classNames from '../../../../utility/classNames';

export default function BeforeAfterCalculationsSection({ section, data }) {
  if (!section) return null;

  const {
    beforeSchema,
    schema: afterSchema,
    percentageValue,
    annualValue,
    beforeLabel,
    afterLabel,
    sectionSubLabel,
  } = section;

  return (
    <div className="w-full h-full rounded bg-primary-50 relative pt-3">
      <h2 className="w-full flex justify-between items-center tracking-wider text-md font-medium text-primary pb-[3px] px-3">
        <span className="py-1 ">{section.sectionLabel?.toUpperCase()}</span>
        {sectionSubLabel && (
          <span className="pr-1 text-sm text-neutral-500">
            {sectionSubLabel}
          </span>
        )}
      </h2>
      <div className="rounded relative bg-white shadow-md w-full h-[calc(100%-32px)]">
        <div className="grid grid-cols-2">
          <div className="col-span-2 sm:col-span-1">
            <h3 className="w-full text-md font-medium text-center mt-6 -mb-2 text-neutral-600">
              {beforeLabel}
            </h3>
            <div className="w-full flex flex-col gap-4 pt-8 px-6 pb-4 justify-center items-center text-neutral-600">
              {beforeSchema?.map((field, index) => (
                <div
                  key={`${field.name} ${index}`}
                  className="w-full flex justify-between gap-3 items-center -mr-2"
                >
                  <CalculatedField
                    field={field}
                    fieldValue={data[field.name]}
                    sectionType="twoColumn"
                    data={data}
                    percentageValue={percentageValue}
                    annualValue={annualValue}
                  />
                  {field.type !== FormUIOptions.Blank && (
                    <IoIosArrowRoundForward
                      className={classNames(
                        'hidden sm:block text-2xl -mr-7',
                        field.groupEnd && 'mb-5',
                        field.groupStart && 'mt-5',
                        field.emphasize && 'text-primary'
                      )}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="col-span-2 sm:col-span-1">
            <h3 className="w-full text-md font-medium text-center mt-6 -mb-2">
              {afterLabel}
            </h3>
            <div className="w-full flex flex-col gap-4 pt-8 px-6 pb-4 justify-center items-center">
              {afterSchema?.map((field, index) => (
                <CalculatedField
                  key={`${field.name} ${index}`}
                  field={field}
                  fieldValue={data[field.name]}
                  sectionType="twoColumn"
                  data={data}
                  percentageValue={percentageValue}
                  annualValue={annualValue}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
